<div [class.selection-invisible]="!selectionVisible()" class="wrapper-mobile-selection-item">
  @if (selectionVisible()) {
    <div @mobileSelectionAnimation class="checkbox-wrapper">
      <mat-checkbox (change)="selected.set($event.checked)" [checked]="selected()">
      </mat-checkbox>
    </div>
  }

  <div [class.selection-visible]="selectionVisible()" class="content-wrapper">
    <ng-content></ng-content>
  </div>
</div>